/**
 * Backend API base URLs. Override at build/dev time with REACT_APP_API_URL or
 * scripts/with-api-env.sh prod|test (sets REACT_APP_API_URL + REACT_APP_API_BASE_URL).
 */

export const PROD_DATABASE_API_BASE_URL =
  'https://7s8495kwo0.execute-api.eu-west-2.amazonaws.com/prod';

export const TEST_DATABASE_API_BASE_URL =
  'https://hifcw2fu1i.execute-api.eu-west-2.amazonaws.com/test';

/** Database API (venues, bookings, auth, payments, …) */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  PROD_DATABASE_API_BASE_URL;

/** Google/Outlook calendar sync API (unchanged when switching database API to test). */
export const CALENDAR_API_BASE_URL =
  process.env.REACT_APP_CALENDAR_API_URL ||
  'https://28j0yje9nl.execute-api.eu-west-2.amazonaws.com/Prod';

/**
 * Calendar Lambda routes live under `/calendar/...` on the calendar API Gateway.
 * Prod: …/Prod/calendar/busy — Test: …/Prod/calendar/busy (see REACT_APP_CALENDAR_API_URL).
 */
export function buildCalendarApiUrl(path = '') {
  const base = String(CALENDAR_API_BASE_URL || '').replace(/\/+$/, '');
  const segment = String(path || '').replace(/^\/+/, '');
  if (!segment) return base;
  if (segment.startsWith('calendar/')) {
    return `${base}/${segment}`;
  }
  return `${base}/calendar/${segment}`;
}
